var _symbol, _symbol2, _symbol3, _symbol4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc727",
    style: {
      fill: "var(--color3, #ffc727)"
    },
    d: "M21.94 4.396c-2.263-0.566-4.526-1.698-6.223-3.397-1.697 1.698-3.96 2.83-6.223 3.397 0.566 5.095 2.263 8.491 6.223 11.322 3.96-2.831 6.223-6.227 6.223-11.322z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbfbfb",
    style: {
      fill: "var(--color4, #fbfbfb)"
    },
    d: "M19.677 25.474l-15.84-18.681v9.057l12.446 14.152 3.394-4.529z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbfbfb",
    style: {
      fill: "var(--color4, #fbfbfb)"
    },
    d: "M21.374 23.776l6.789-7.925v-8.491l-10.749 12.454 3.96 3.963z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbfbfb",
    style: {
      fill: "var(--color4, #fbfbfb)"
    },
    d: "M21.94 26.606v5.095l6.223-7.359v-5.095l-6.223 7.359z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbfbfb",
    style: {
      fill: "var(--color4, #fbfbfb)"
    },
    d: "M10.060 26.606l-6.223-7.359v5.095l6.223 7.359v-5.095z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-email",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    opacity: 0.4,
    d: "M26.667 5.333h-21.333c-1.467 0-2.653 1.2-2.653 2.667l-0.013 16c0 1.467 1.2 2.667 2.667 2.667h21.333c1.467 0 2.667-1.2 2.667-2.667v-16c0-1.467-1.2-2.667-2.667-2.667zM26.667 10.667l-10.667 6.667-10.667-6.667v-2.667l10.667 6.667 10.667-6.667v2.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-password",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    opacity: 0.4,
    d: "M24 10.667h-1.333v-2.667c0-3.68-2.987-6.667-6.667-6.667s-6.667 2.987-6.667 6.667v2.667h-1.333c-1.467 0-2.667 1.2-2.667 2.667v13.333c0 1.467 1.2 2.667 2.667 2.667h16c1.467 0 2.667-1.2 2.667-2.667v-13.333c0-1.467-1.2-2.667-2.667-2.667zM16 22.667c-1.467 0-2.667-1.2-2.667-2.667s1.2-2.667 2.667-2.667c1.467 0 2.667 1.2 2.667 2.667s-1.2 2.667-2.667 2.667zM20.133 10.667h-8.267v-2.667c0-2.28 1.853-4.133 4.133-4.133s4.133 1.853 4.133 4.133v2.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-exit-logout",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    opacity: 0.6,
    d: "M20.051 23.237h2.499v4.997c0 2.067-1.681 3.748-3.748 3.748h-15.054c-2.066 0-3.748-1.681-3.748-3.748v-24.486c0-2.066 1.681-3.748 3.748-3.748h15.054c2.067 0 3.748 1.681 3.748 3.748v4.997h-2.499v-4.997c0-0.689-0.56-1.249-1.249-1.249h-15.054c-0.689 0-1.249 0.561-1.249 1.249v24.486c0 0.689 0.561 1.249 1.249 1.249h15.054c0.689 0 1.249-0.561 1.249-1.249v-4.997zM26.111 10.102l-1.767 1.767 2.873 2.874h-16.161v2.499h16.161l-2.873 2.873 1.767 1.767 5.889-5.889-5.889-5.89z"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-home",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.545 2.182c-2.41 0-4.364 1.954-4.364 4.364v18.909c0 2.41 1.954 4.364 4.364 4.364h18.909c2.41 0 4.364-1.954 4.364-4.364v-18.909c0-2.41-1.954-4.364-4.364-4.364h-18.909zM13.77 17.716v5.961h-4.97v-7.948h-2.982l9.939-8.941 9.939 8.941h-2.982v7.948h-4.97v-5.961h-3.976z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fbfbfb",
    style: {
      stroke: "var(--color3, #fbfbfb)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.2,
    d: "M16 0v32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fbfbfb",
    style: {
      stroke: "var(--color3, #fbfbfb)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.2,
    d: "M0 16h32"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-minis",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.2,
    d: "M0 16h32"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fbfbfb",
    style: {
      stroke: "var(--color3, #fbfbfb)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.7778,
    d: "M1.778 1.778l28.444 28.444"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fbfbfb",
    style: {
      stroke: "var(--color3, #fbfbfb)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.7778,
    d: "M1.778 30.222l28.444-28.444"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#734aef",
    style: {
      fill: "var(--color2, #734aef)"
    },
    d: "M12 14.667h-2.667v2.667h2.667v-2.667zM17.333 14.667h-2.667v2.667h2.667v-2.667zM22.667 14.667h-2.667v2.667h2.667v-2.667zM25.333 5.333h-1.333v-2.667h-2.667v2.667h-10.667v-2.667h-2.667v2.667h-1.333c-1.48 0-2.653 1.2-2.653 2.667l-0.013 18.667c0 1.467 1.187 2.667 2.667 2.667h18.667c1.467 0 2.667-1.2 2.667-2.667v-18.667c0-1.467-1.2-2.667-2.667-2.667zM25.333 26.667h-18.667v-14.667h18.667v14.667z"
  })), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pen",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.56,
    d: "M23.467 13.511l-4.978-4.978M4.178 27.823l4.212-0.468c0.515-0.057 0.772-0.086 1.012-0.164 0.213-0.069 0.416-0.167 0.604-0.29 0.211-0.139 0.394-0.322 0.76-0.688l16.435-16.434c1.375-1.375 1.375-3.603 0-4.978s-3.603-1.375-4.978 0l-16.434 16.434c-0.366 0.366-0.549 0.549-0.688 0.76-0.123 0.187-0.221 0.39-0.29 0.604-0.078 0.24-0.106 0.498-0.164 1.012l-0.468 4.212z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-dollar-2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.545 2.182c-2.41 0-4.364 1.954-4.364 4.364v18.909c0 2.41 1.954 4.364 4.364 4.364h18.909c2.41 0 4.364-1.954 4.364-4.364v-18.909c0-2.41-1.954-4.364-4.364-4.364h-18.909zM13.638 13.526c0 0.86 0.661 1.412 2.715 1.946s4.253 1.412 4.253 3.982c0 1.855-1.403 2.878-3.167 3.212v1.946h-2.715v-1.964c-1.737-0.371-3.222-1.484-3.33-3.466h1.991c0.1 1.068 0.833 1.9 2.697 1.9 2 0 2.443-0.995 2.443-1.62 0-0.842-0.452-1.638-2.715-2.181-2.525-0.606-4.253-1.647-4.253-3.737 0-1.747 1.412-2.887 3.167-3.267v-1.955h2.715v1.982c1.891 0.462 2.841 1.891 2.905 3.448h-2c-0.054-1.131-0.651-1.9-2.262-1.9-1.529 0-2.443 0.688-2.443 1.674z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-account",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    opacity: 0.4,
    d: "M4 6.667v18.667c0 1.467 1.187 2.667 2.667 2.667h18.667c1.467 0 2.667-1.2 2.667-2.667v-18.667c0-1.467-1.2-2.667-2.667-2.667h-18.667c-1.48 0-2.667 1.2-2.667 2.667zM20 12c0 2.213-1.787 4-4 4s-4-1.787-4-4c0-2.213 1.787-4 4-4s4 1.787 4 4zM8 22.667c0-2.667 5.333-4.133 8-4.133s8 1.467 8 4.133v1.333h-16v-1.333z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow",
    viewBox: "0 0 58 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fbfbfb",
    style: {
      stroke: "var(--color1, #fbfbfb)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.9091,
    d: "M55.273 29.091l-26.182-26.182-26.182 26.182"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgba(255, 255, 255, 0.4)",
    style: {
      fill: "var(--color1, rgba(255, 255, 255, 0.4))"
    },
    d: "M16 11c-2.761 0-5 2.239-5 5s2.239 5 5 5c2.761 0 5-2.239 5-5s-2.239-5-5-5zM13 16c0-1.657 1.343-3 3-3s3 1.343 3 3c0 1.657-1.343 3-3 3s-3-1.343-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(255, 255, 255, 0.4)",
    style: {
      fill: "var(--color1, rgba(255, 255, 255, 0.4))"
    },
    d: "M16 4.333c-6.019 0-10.073 3.606-12.426 6.662l-0.042 0.055c-0.532 0.691-1.022 1.328-1.355 2.080-0.356 0.806-0.51 1.684-0.51 2.869s0.154 2.063 0.51 2.869c0.333 0.753 0.823 1.389 1.355 2.080l0.042 0.055c2.353 3.057 6.407 6.663 12.426 6.663s10.073-3.606 12.426-6.663l0.042-0.055c0.532-0.691 1.022-1.328 1.355-2.080 0.356-0.806 0.51-1.684 0.51-2.869s-0.154-2.063-0.51-2.869c-0.333-0.753-0.823-1.389-1.355-2.080l-0.042-0.055c-2.353-3.057-6.407-6.662-12.426-6.662zM5.159 12.216c2.173-2.822 5.708-5.882 10.841-5.882s8.669 3.060 10.841 5.882c0.585 0.76 0.927 1.214 1.153 1.724 0.211 0.477 0.34 1.059 0.34 2.061s-0.129 1.584-0.34 2.061c-0.225 0.51-0.568 0.964-1.153 1.724-2.173 2.823-5.708 5.882-10.841 5.882s-8.668-3.060-10.841-5.882c-0.585-0.76-0.927-1.214-1.153-1.724-0.211-0.477-0.34-1.059-0.34-2.061s0.129-1.584 0.34-2.061c0.225-0.51 0.568-0.964 1.153-1.724z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye-closed",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgba(255, 255, 255, 0.4)",
    style: {
      fill: "var(--color1, rgba(255, 255, 255, 0.4))"
    },
    d: "M3.586 8.939c-0.218-0.508-0.805-0.743-1.313-0.525s-0.743 0.805-0.525 1.313l1.838-0.788zM20.783 17.772v0zM12.055 18.317c0.301-0.463 0.17-1.082-0.293-1.383s-1.082-0.17-1.384 0.293l1.676 1.091zM8.495 20.121c-0.301 0.463-0.17 1.082 0.293 1.383s1.082 0.17 1.384-0.293l-1.676-1.091zM30.253 9.727c0.217-0.508-0.018-1.095-0.525-1.313s-1.095 0.018-1.313 0.525l1.838 0.788zM25.333 14.838v0zM26.626 17.546c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-1.414 1.414zM15 22c0 0.552 0.448 1 1 1s1-0.448 1-1h-2zM21.829 21.212c0.301 0.463 0.921 0.594 1.383 0.293s0.594-0.921 0.293-1.383l-1.676 1.091zM7.374 15.546c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l1.414 1.414zM3.96 16.131c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l-1.414-1.414zM16 17.667c-4.299 0-7.385-2.141-9.434-4.347-1.024-1.103-1.775-2.209-2.269-3.039-0.247-0.414-0.428-0.757-0.546-0.993-0.059-0.118-0.102-0.209-0.13-0.268-0.014-0.030-0.024-0.052-0.030-0.065-0.003-0.007-0.005-0.011-0.006-0.014-0.001-0.001-0.001-0.002-0.001-0.002s0 0 0 0 0 0 0 0 0 0.001-0.919 0.395-0.919 0.394-0.919 0.395 0 0.001 0 0.001 0.001 0.002 0.001 0.003 0.002 0.005 0.004 0.008 0.007 0.015 0.012 0.026c0.010 0.022 0.024 0.052 0.041 0.091 0.036 0.077 0.088 0.187 0.156 0.324 0.137 0.274 0.342 0.661 0.616 1.122 0.547 0.92 1.38 2.147 2.522 3.377 2.284 2.46 5.865 4.986 10.899 4.986v-2zM20.417 16.841c-1.294 0.509-2.761 0.826-4.417 0.826v2c1.918 0 3.633-0.368 5.149-0.965l-0.733-1.861zM10.379 17.226l-1.884 2.895 1.676 1.091 1.884-2.895-1.676-1.091zM29.333 9.333c-0.919-0.394-0.919-0.394-0.919-0.394s0-0 0-0 0-0 0-0 0-0 0-0-0.001 0.001-0.001 0.003-0.004 0.009-0.008 0.018c-0.008 0.017-0.020 0.045-0.038 0.083-0.035 0.075-0.090 0.189-0.164 0.335-0.149 0.293-0.378 0.714-0.69 1.214-0.625 1.003-1.572 2.305-2.865 3.518l1.369 1.458c1.452-1.363 2.505-2.813 3.194-3.919 0.345-0.554 0.602-1.026 0.774-1.363 0.086-0.169 0.151-0.304 0.195-0.399 0.022-0.048 0.039-0.085 0.051-0.112 0.006-0.013 0.011-0.024 0.014-0.032 0.002-0.004 0.003-0.007 0.004-0.010 0.001-0.001 0.001-0.002 0.001-0.003s0-0.001 0.001-0.001 0-0 0-0.001 0-0-0.919-0.394zM24.649 14.109c-1.145 1.075-2.55 2.070-4.232 2.732l0.733 1.861c1.965-0.773 3.58-1.925 4.869-3.135l-1.369-1.458zM24.626 15.546l2 2 1.414-1.414-2-2-1.414 1.414zM15 18.667v3.333h2v-3.333h-2zM19.945 18.317l1.884 2.895 1.676-1.091-1.884-2.895-1.676 1.091zM5.96 14.131l-2 2 1.414 1.414 2-2-1.414-1.414z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-1",
    viewBox: "0 0 58 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fbfbfb",
    style: {
      stroke: "var(--color1, #fbfbfb)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.9091,
    d: "M55.273 2.909l-26.182 26.182-26.182-26.182"
  })), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-diagram",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.545 2.182h18.909c2.41 0 4.364 1.954 4.364 4.364v18.909c0 2.41-1.954 4.364-4.364 4.364h-18.909c-2.41 0-4.364-1.954-4.364-4.364v-18.909c0-2.41 1.954-4.364 4.364-4.364zM23.636 14.222c0.933 0 1.697-0.8 1.697-1.778s-0.764-1.778-1.697-1.778c-0.933 0-1.697 0.8-1.697 1.778 0 0.16 0.017 0.311 0.059 0.453l-3.012 3.164c-0.136-0.044-0.288-0.062-0.441-0.062s-0.305 0.018-0.441 0.062l-2.164-2.267c0.042-0.142 0.059-0.302 0.059-0.462 0-0.978-0.764-1.778-1.697-1.778s-1.697 0.8-1.697 1.778c0 0.16 0.017 0.32 0.059 0.462l-3.869 4.044c-0.136-0.044-0.28-0.062-0.433-0.062-0.933 0-1.697 0.8-1.697 1.778s0.764 1.778 1.697 1.778c0.933 0 1.697-0.8 1.697-1.778 0-0.16-0.017-0.311-0.059-0.453l3.861-4.053c0.136 0.044 0.288 0.062 0.441 0.062s0.305-0.018 0.441-0.062l2.164 2.267c-0.042 0.142-0.059 0.302-0.059 0.462 0 0.978 0.764 1.778 1.697 1.778s1.697-0.8 1.697-1.778c0-0.16-0.017-0.32-0.059-0.462l3.021-3.156c0.136 0.044 0.28 0.062 0.433 0.062z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-wallet-svgrepo-com",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M24.393 11.541h-5.246v1.049h5.246c0.868 0 1.574 0.706 1.574 1.574v2.112c-0.44-0.333-0.981-0.538-1.574-0.538h-16.787c-0.868 0-1.574-0.706-1.574-1.574s0.706-1.574 1.574-1.574h5.771v-1.049h-5.771c-1.446 0-2.623 1.177-2.623 2.623v15.213c0 1.446 1.177 2.623 2.623 2.623h16.787c1.446 0 2.623-1.177 2.623-2.623v-15.213c-0-1.446-1.177-2.623-2.623-2.623zM25.967 26.754h-6.295c-1.446 0-2.623-1.177-2.623-2.623s1.177-2.623 2.623-2.623h6.295v5.246zM25.967 20.459h-6.295c-2.025 0-3.672 1.648-3.672 3.672s1.647 3.672 3.672 3.672h6.295v1.574c0 0.868-0.706 1.574-1.574 1.574h-16.787c-0.868 0-1.574-0.706-1.574-1.574v-13.116c0.439 0.33 0.984 0.526 1.574 0.526h16.787c0.868 0 1.574 0.706 1.574 1.574v2.098z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M7.607 13.639h16.787v1.049h-16.787v-1.049z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9ba48",
    style: {
      fill: "var(--color2, #f9ba48)"
    },
    d: "M20.197 9.967c0 2.318-1.879 4.197-4.197 4.197s-4.197-1.879-4.197-4.197c0-2.318 1.879-4.197 4.197-4.197s4.197 1.879 4.197 4.197z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M16.525 11.541h-1.049c-0.289 0-0.525-0.236-0.525-0.525h-1.049c0 0.868 0.706 1.574 1.574 1.574v0.525h1.049v-0.525c0.868 0 1.574-0.706 1.574-1.574s-0.706-1.574-1.574-1.574h-1.049c-0.289 0-0.525-0.236-0.525-0.525s0.236-0.524 0.525-0.524h1.049c0.289 0 0.525 0.236 0.525 0.525h1.049c0-0.868-0.706-1.574-1.574-1.574v-0.525h-1.049v0.525c-0.868 0-1.574 0.706-1.574 1.574s0.706 1.574 1.574 1.574h1.049c0.289 0 0.525 0.236 0.525 0.525s-0.236 0.524-0.525 0.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M18.098 24.131c0 0.868 0.706 1.574 1.574 1.574s1.574-0.706 1.574-1.574-0.706-1.574-1.574-1.574-1.574 0.706-1.574 1.574zM20.197 24.131c0 0.29-0.236 0.525-0.525 0.525s-0.525-0.235-0.525-0.525 0.236-0.525 0.525-0.525 0.525 0.235 0.525 0.525z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M15.475 0h1.049v4.197h-1.049v-4.197z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M19.148 1.574h1.049v4.197h-1.049v-4.197z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M11.803 2.623h1.049v3.148h-1.049v-3.148z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-vector",
    viewBox: "0 0 15 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.9091,
    d: "M12.802 1.597l-11.058 28.806"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit",
    viewBox: "0 0 30 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.56,
    d: "M22.4 13.511l-4.978-4.978M3.111 27.823l4.212-0.468c0.515-0.057 0.772-0.086 1.012-0.164 0.213-0.069 0.416-0.167 0.604-0.29 0.211-0.139 0.394-0.322 0.76-0.688l16.435-16.434c1.375-1.375 1.375-3.603 0-4.978s-3.603-1.375-4.978 0l-16.434 16.434c-0.366 0.366-0.549 0.549-0.688 0.76-0.123 0.187-0.221 0.39-0.29 0.604-0.078 0.24-0.106 0.498-0.164 1.012l-0.468 4.212z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-time-money",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9ba48",
    style: {
      fill: "var(--color1, #f9ba48)"
    },
    d: "M19.185 14.975c0 3.68-2.983 6.664-6.664 6.664s-6.664-2.983-6.664-6.664c0-3.68 2.983-6.664 6.664-6.664s6.664 2.983 6.664 6.664z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M25.336 18.563c-1.069 0-2.077 0.259-2.973 0.709 0.592-1.347 0.902-2.799 0.902-4.297 0-2.321-0.746-4.467-2-6.227l0.669-0.669 0.906 0.906 2.174-2.174-4.349-4.349-2.175 2.174 0.906 0.906-0.787 0.669c-1.295-0.924-2.5-1.563-4.551-1.839v-1.187h1.538v-3.076h-6.151v3.076h1.025v1.187c-1.538 0.275-3.010 0.91-4.304 1.829l-0.602-0.661 0.936-0.906-2.16-2.174-4.342 4.349 2.179 2.174 0.908-0.906 0.659 0.658c-1.26 1.763-2.009 3.913-2.009 6.239 0 4.966 3.435 9.288 8.222 10.45v0.315h1.025v2.050h0.513v1.025h-1.025v3.076h13.327v-0.186c0.495 0.117 1.008 0.186 1.538 0.186 3.674 0 6.664-2.989 6.664-6.664s-2.99-6.663-6.664-6.663zM16.622 28.815v-1.025h1.025v1.025h-1.025zM16.11 23.689v1.025h-1.025v-1.025h1.025zM17.135 24.714v-1.025h1.025v1.025h-1.025zM17.135 25.739v1.025h-1.025v-1.025h1.025zM18.16 26.764v-1.025h0.539c0.027 0.35 0.081 0.692 0.16 1.025h-0.699zM17.647 22.664v-1.025h1.025v1.025h-1.025zM16.622 22.664h-1.025v-1.025h1.025v1.025zM14.572 22.664h-1.025v-1.025h1.025v1.025zM12.521 22.664h-1.025v-1.025h1.025v1.025zM14.059 23.689v1.025h-1.025v-1.025h1.025zM15.084 25.739v1.025h-1.025v-1.025h1.025zM15.597 27.79v1.025h-1.025v-1.025h1.025zM14.572 29.84v1.025h-1.025v-1.025h1.025zM15.597 29.84h1.025v1.025h-1.025v-1.025zM17.647 29.84h1.025v1.025h-1.025v-1.025zM18.672 28.815v-1.025h0.514c0.15 0.359 0.335 0.701 0.543 1.025h-1.058zM19.698 21.639h0.032c-0.011 0.017-0.022 0.035-0.032 0.053v-0.053zM20.666 3.91l2.9 2.9-0.725 0.725-2.9-2.9 0.725-0.725zM20.123 6.266l1.087 1.087-0.583 0.583c-0.336-0.388-0.7-0.751-1.087-1.088l0.583-0.583zM10.471 2.16v-1.025h4.101v1.025h-4.101zM11.496 4.21v-1.025h1.538v1.025h-1.538zM1.457 6.81l2.9-2.9 0.725 0.725-2.9 2.9-0.725-0.725zM3.813 7.354l1.087-1.087 0.573 0.573c-0.389 0.336-0.751 0.699-1.088 1.086l-0.572-0.572zM2.762 14.975c0-5.37 4.369-9.739 9.739-9.739s9.739 4.369 9.739 9.739c0 2.035-0.632 3.977-1.82 5.639h-9.949v2.050h-0.513v1.706c-4.204-1.135-7.197-4.985-7.197-9.395zM10.984 23.689h1.025v1.025h-1.025v-1.025zM13.034 25.739v1.025h-1.025v-1.025h1.025zM12.521 27.79h1.025v1.025h-1.025v-1.025zM11.496 29.84h1.025v1.025h-1.025v-1.025zM19.698 30.865v-1.025h0.841c0.376 0.392 0.801 0.735 1.262 1.025h-2.104zM25.336 30.865c-3.109 0-5.639-2.53-5.639-5.638s2.53-5.639 5.639-5.639 5.639 2.53 5.639 5.639-2.53 5.638-5.639 5.638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M26.618 21.126h-0.769v-1.025h-1.025v1.025h-0.769c-1.272 0-2.307 1.035-2.307 2.307s1.035 2.307 2.307 2.307h2.563c0.706 0 1.282 0.575 1.282 1.282s-0.575 1.282-1.282 1.282h-2.563c-0.706 0-1.282-0.575-1.282-1.282v-0.256h-1.025v0.256c0 1.272 1.035 2.307 2.307 2.307h0.769v1.025h1.025v-1.025h0.769c1.272 0 2.307-1.035 2.307-2.307s-1.035-2.307-2.307-2.307h-2.563c-0.706 0-1.282-0.575-1.282-1.282s0.575-1.282 1.282-1.282h2.563c0.706 0 1.282 0.575 1.282 1.282v0.256h1.025v-0.256c0-1.272-1.035-2.307-2.307-2.307z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M10.963 14.975c0 0.848 0.69 1.538 1.538 1.538s1.538-0.69 1.538-1.538c0-0.848-0.69-1.538-1.538-1.538-0.221 0-0.43 0.049-0.62 0.133l-3.61-4.061-0.766 0.681 3.634 4.088c-0.108 0.211-0.175 0.445-0.175 0.698zM13.014 14.975c0 0.283-0.23 0.513-0.513 0.513s-0.513-0.23-0.513-0.513 0.23-0.513 0.513-0.513c0.283 0 0.513 0.23 0.513 0.513z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.96d254ee9a0f326f8b0477924ed34252.svg";
export { ForwardRef as ReactComponent };